import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { useConcreteNotificationsContext } from '../../ConcreteNotificationsContext'
import { Space } from 'antd'
import RecipientsTags from 'components/CIMSTags/common/RecipientsTags'
import CIMSCollapse from 'components/CIMSCollapse'
import NotConfigured from './components/NotConfigured'
import GroupFallback from '../GroupFallback'
import { HelpMessage } from 'utils/constants'
import { alphabeticalSort } from 'shared'
import CIMSSection from 'components/CIMSSection'
const Help = HelpMessage.Concrete.Notifications

const ViewConcreteNotificationEvent: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  const { data } = useConcreteNotificationsContext()
  const { every, byConcreteMaterial, byConcreteMixDesign } =
    useConcreteNotificationsContext().recipients(event)

  const eventName = event.name
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <CIMSSection
        help={HelpMessage.Notifications.Every(event, 'Concrete Test Set')}
        title={'Every ' + { eventName } + ' Event'}
      >
        <RecipientsTags
          noRecipientsContent={<NotConfigured type="every" />}
          recipients={every}
        />
      </CIMSSection>
      <CIMSSection
        help={Help.ByConcreteMaterial(event)}
        title="Concrete Material"
      >
        <CIMSCollapse
          noPanelsContent={<GroupFallback group="Concrete Materials" />}
          panels={data?.concreteMaterials
            ?.sort(alphabeticalSort('placementType'))
            .map(({ globalId: key, placementType }) => {
              const recipients = byConcreteMaterial.find(
                ({ concreteMaterial }) => concreteMaterial.globalId === key
              )?.recipients
              return {
                header: placementType ?? '',
                key,
                children: (
                  <RecipientsTags
                    noRecipientsContent={
                      <NotConfigured
                        type="group"
                        groupName={'Concrete Material'}
                        itemName={placementType ?? ''}
                      />
                    }
                    recipients={recipients}
                  />
                ),
              }
            })}
        />
      </CIMSSection>
      <CIMSSection
        help={Help.ByConcreteMixDesign(event)}
        title="Concrete Mix Design"
      >
        <CIMSCollapse
          noPanelsContent={<GroupFallback group="Concrete Mix Designs" />}
          panels={data?.concreteMixDesigns
            ?.sort(alphabeticalSort('mixDesignNumber'))
            .map(({ globalId: key, mixDesignNumber }) => {
              const recipients = byConcreteMixDesign.find(
                ({ concreteMixDesign }: any) =>
                  concreteMixDesign.globalId === key
              )?.recipients
              return {
                header: mixDesignNumber ?? '',
                key,
                children: (
                  <RecipientsTags
                    noRecipientsContent={
                      <NotConfigured
                        type="group"
                        groupName={'Concrete Mix Design'}
                        itemName={mixDesignNumber ?? ''}
                      />
                    }
                    recipients={recipients}
                  />
                ),
              }
            })}
        />
      </CIMSSection>
    </Space>
  )
}

export default ViewConcreteNotificationEvent
